@if (edit) {
    <clp-toolbar [title]="('community.update.title' | translate)"></clp-toolbar>
}
@else {
    <clp-toolbar [title]="('community.create.title' | translate)"></clp-toolbar>
}

<div class="mt-10 flex justify-center">
    <div class="w-full max-w-lg">
        <form class="space-y-4" (ngSubmit)="changeCommunity(communityForm.value)" [formGroup]="communityForm" novalidate>
            <input type="hidden" formControlName="id">

            <div>
                <label class="clp-label">{{ 'community.create.name' | translate }}</label>
                <input class="clp-input" formControlName="name">
                @if (communityForm.controls['name'].invalid && communityForm.controls['name'].touched) {
                    <em class="clp-help">{{ 'community.create.invalidName' | translate }}</em>
                }
            </div>

            <div>
                <label class="clp-label">{{ 'community.subscription' | translate }}</label>
                <select class="clp-select" formControlName="subscriptionId">
                    <option value="">{{ 'community.noSubscription' | translate }}</option>
                    @if (subscriptions$ | async; as subscriptions) {
                        @for (subscription of subscriptions; track subscription.id ?? $index) {
                            <option [value]="subscription.id">{{ subscription.name }}</option>
                        }
                    }
                </select>
            </div>

            <p class="clp-help">{{ 'community.create.groupAutoCreated' | translate }}</p>

            <div class="flex justify-end gap-2">
                <a class="clp-btn clp-btn-secondary" [routerLink]="['/listCommunities']">{{ 'general.cancel' | translate }}</a>
                <button class="clp-btn clp-btn-warning" type="submit">{{ 'general.save' | translate }}</button>
            </div>
        </form>
    </div>
</div>
